<template>
  <div class="login-page fill-height">
    <v-row no-gutters class="login-row">
      <v-col cols="12" md="6" class="login-brand pa-8 pa-md-12 d-none d-md-flex flex-column justify-center">
        <div class="login-brand__inner">
          <v-icon color="white" size="56" class="login-brand__icon">mdi-view-dashboard-outline</v-icon>
          <h1 class="login-brand__title">Plataforma KPI</h1>
          <p class="login-brand__subtitle">
            Herramientas y métricas en un solo lugar. Accede con tu cuenta institucional.
          </p>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="login-form-col pa-6 pa-sm-10 pa-md-12 d-flex align-center justify-center">
        <div class="login-form-wrap">
          <div class="text-center mb-8">
            <v-img
              src="@/assets/logo.png"
              max-height="52"
              contain
              class="mx-auto login-logo"
              alt="School of English"
            />
          </div>

          <header class="text-center mb-6">
            <h2 class="login-heading">Bienvenido</h2>
            <p class="login-lead">Ingresa tus credenciales para continuar</p>
          </header>

          <v-alert
            v-if="sessionNotice"
            :type="sessionNotice.type"
            dense
            outlined
            prominent
            class="mb-4 text-left"
          >
            <v-row align="center" class="flex-nowrap">
              <v-col class="shrink py-0">
                <v-icon>{{ sessionNotice.icon }}</v-icon>
              </v-col>
              <v-col class="py-0">
                <strong v-if="sessionNotice.title">{{ sessionNotice.title }}</strong>
                <div class="body-2">{{ sessionNotice.text }}</div>
              </v-col>
            </v-row>
            <div class="text-right mt-2">
              <v-btn text small color="primary" class="text-none" @click="clearReasonQuery"> Entendido </v-btn>
            </div>
          </v-alert>

          <v-alert v-if="formError" type="error" dense outlined class="mb-4">
            {{ formError }}
          </v-alert>

          <v-form @submit.prevent="validate">
            <label class="login-label">Correo institucional</label>
            <v-text-field
              v-model="email"
              placeholder="usuario@schoolofenglish.com"
              outlined
              dense
              hide-details="auto"
              autocomplete="username"
              prepend-inner-icon="mdi-email-outline"
              class="mb-4"
              :rules="[rules.required]"
            />

            <label class="login-label">Contraseña</label>
            <v-text-field
              v-model="password"
              placeholder="••••••••"
              outlined
              dense
              hide-details="auto"
              autocomplete="current-password"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              class="mb-2"
              :rules="[rules.required]"
              @click:append="showPassword = !showPassword"
              @keyup.enter="validate"
            />

            <v-btn
              type="submit"
              block
              depressed
              x-large
              color="primary"
              class="login-submit text-none font-weight-semibold mt-2"
              :loading="cargar"
              :disabled="cargar"
            >
              <v-icon left small>mdi-login</v-icon>
              Iniciar sesión
            </v-btn>
          </v-form>

          <p class="login-footnote text-center mt-8 mb-0">
            <router-link :to="{ name: 'OlvideContrasena' }" class="login-link">
              ¿Olvidaste tu contraseña?
            </router-link>
          </p>
          <p class="login-footnote text-center mt-2 mb-0">
            ¿Problemas para ingresar? Contácta a sistemas
          </p>
        </div>
      </v-col>
    </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'Login',

  components: {
    Alerta,
    carga,
  },

  mixins: [validarErrores],

  data() {
    return {
      acceso: false,
      cargo: '',
      datos_usuario: {},
      password: '',
      email: '',
      showPassword: false,
      formError: '',
      rules: {
        required: (value) => !!value || 'Campo requerido',
      },
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    sessionNotice() {
      const reason = this.$route.query.reason
      if (reason === 'no-permisos') {
        return {
          type: 'warning',
          icon: 'mdi-shield-off-outline',
          title: 'Sin permisos',
          text: 'No tienes ningún permiso asignado para usar la plataforma. Si crees que es un error, avisa a sistemas o a tu supervisor.',
        }
      }
      if (reason === 'idle') {
        return {
          type: 'info',
          icon: 'mdi-clock-outline',
          title: 'Sesión cerrada',
          text: 'Tu sesión se cerró por inactividad. Vuelve a iniciar sesión para continuar.',
        }
      }
      return null
    },
  },

  watch: {
    '$route.query.reason'() {
      this.formError = ''
    },
  },

  async created() {
    await this.initialize()
  },

  methods: {
    ...mapActions('login', ['guardarInfo', 'salirLogin']),

    clearReasonQuery() {
      this.$router.replace({ name: 'Login', query: {} }).catch(() => {})
    },

    initialize() {
      if (!this.$route.params.id) return

      this.$http.get('usuarios.id/' + this.$route.params.id).then((response) => {
        if (!response.data.idusuario) {
          this.salirLogin()
          return
        }
        this.datos_usuario = response.data
        this.$http.get('usuarios.all.capa/' + this.datos_usuario.iderp).then((capaRes) => {
          if (capaRes.data.length === 0) {
            this.salirLogin()
            return
          }
          this.$http.get('tickets.usuarios.getCargo/' + this.$route.params.id).then((responseR) => {
            this.cargo = responseR.data
            if (this.cargo.cargo === 'Sin cargo, no permitir el acceso') {
              this.acceso = true
              this.datos_usuario.cargo = 'Normal'
              this.datos_usuario.permiso = { area: 'Sin asignar' }
              this.assignUsuarioFields(capaRes.data[0])
              this.$router.push({ name: 'dashboard' })
              this.guardarInfo(this.datos_usuario)
            } else {
              this.datos_usuario.cargo = this.cargo.cargo
              this.datos_usuario.permiso = this.cargo.permiso
              this.assignUsuarioFields(capaRes.data[0])
              this.$router.push({ name: 'dashboard' })
              this.guardarInfo(this.datos_usuario)
            }
          }).catch(() => {
            this.salirLogin()
          })
        }).catch(() => {
          this.salirLogin()
        })
      }).catch(() => {
        this.salirLogin()
      })
    },

    assignUsuarioFields(row) {
      this.datos_usuario.nombre_completo = row.nombre_completo
      this.datos_usuario.nombre_usuario = row.nombre_usuario
      this.datos_usuario.apellido_usuario = row.apellido_usuario
      this.datos_usuario.id_plantel = row.id_plantel
      this.datos_usuario.plantel = row.plantel
      this.datos_usuario.email = row.email
      this.datos_usuario.whatsappservidor = row.whatsappservidor
      this.datos_usuario.url_servidor = row.url_servidor
      this.datos_usuario.id_trabajador = row.id_trabajador
    },

    validate() {
      this.formError = ''
      if (!this.email || !this.password) {
        this.formError = 'Ingresa correo y contraseña para continuar.'
        return
      }

      this.cargar = true
      const usuario = { email: this.email, password: this.password }
      this.$http
        .post('usuarios.data', usuario)
        .then(async (response) => {
          await this.guardarInfo(response.data[0])
          this.acceso = true
          this.$router.push({ name: 'Home' }).catch(() => {})
        })
        .catch((error) => {
          // Sin error.response: red, CORS opaco, bloqueo entre sitios (ITP), o abort
          if (!error.response) {
            console.warn('[Login] sin respuesta HTTP:', error.message || error)
          }
          let msg =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : null
          if (!msg) {
            if (!error.response && (error.message === 'Network Error' || !error.message)) {
              msg =
                'Tu navegador no recibió respuesta del servidor (bloqueo de red o entre sitios). ' +
                'Prueba desde otra red o avisa a sistemas para usar el API bajo el mismo dominio kpi.schoolofenglishadmin.com (proxy reverso).'
            } else {
              msg =
                'No fue posible iniciar sesión. Verifica tus datos o intenta más tarde.'
            }
          }
          if (typeof msg !== 'string') msg = 'No fue posible iniciar sesión.'
          this.validarError(msg)
        })
        .finally(() => {
          this.cargar = false
        })
    },
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100%;
  background: #f4f6f9;
}

.login-row {
  min-height: calc(100vh - 0px);
}

.login-brand {
  background: linear-gradient(155deg, #0d1b3e 0%, #1a3a6e 45%, #2563a8 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
}

.login-brand::before {
  content: '';
  position: absolute;
  width: min(420px, 90vw);
  height: min(420px, 90vw);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  top: -18%;
  right: -12%;
  pointer-events: none;
}

.login-brand::after {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  bottom: 10%;
  left: -5%;
  pointer-events: none;
}

.login-brand__inner {
  position: relative;
  z-index: 1;
  max-width: 400px;
}

.login-brand__icon {
  opacity: 0.92;
  margin-bottom: 1.25rem;
}

.login-brand__title {
  font-size: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.25;
  margin-bottom: 0.75rem;
}

.login-brand__subtitle {
  font-size: 0.95rem;
  line-height: 1.55;
  opacity: 0.88;
  font-weight: 400;
  margin: 0;
}

.login-form-col {
  background: #fff;
}

.login-form-wrap {
  width: 100%;
  max-width: 400px;
}

.login-logo {
  max-width: 280px;
}

.login-heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  letter-spacing: -0.02em;
  margin-bottom: 0.35rem;
}

.login-lead {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.login-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  margin-bottom: 0.35rem;
}

.login-submit {
  border-radius: 10px !important;
  letter-spacing: 0.02em;
}

.login-footnote {
  font-size: 0.8125rem;
  color: #94a3b8;
}

.login-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.login-link:hover {
  text-decoration: underline;
}

@media (max-width: 959px) {
  .login-form-col {
    min-height: calc(100vh - 0px);
  }
}
</style>
